<template>
  <div class="page-container">
    <div class="header-container ">
      <header-bar :isImitate="isImitate"></header-bar>
    </div>
    <div class="trade-container">
      <transition :name="transitionName">
        <router-view></router-view>
      </transition>
    </div>

    <div class="modal-bg" v-show="showModalBg"></div>
  </div>
</template>
<script>
import headerBar from '@/components/header'
export default {
  name: 'home',
  components: {
    headerBar
  },
  data() {
    return {
      transitionName: '',
      isImitate: false
    }
  },
  watch: {
    $route(to, from) {
      let name = to.name
      if (name == 'imitate') {
        this.isImitate = true
      } else {
        this.isImitate = false
      }
    },
  },
  computed: {
    showModalBg() {
      return this.$store.state.showModalBg
    },
  },
  mounted() {
    let routeName = this.$route.name
    if (routeName == 'imitate') {
      this.isImitate = true
    } else {
      this.isImitate = false
    }
  }
}
</script>